import { createConsumer, createSubscriber, IEvent } from '@cian/events-log';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { trackRecommendationItemClick, trackTrapRecommendationClick, trackRecommendationsTrapView } from '../tracking';
import { TRecommendationsEvent } from './types';
import { selectDealType } from '../../../utils/jsonQuery/selectDealType';
import { TSectionType } from '../../../types/sectionType';

export const useRecommendationsEventsSubscribe = (section: TSectionType) => {
  const dealType = useSelector(selectDealType);

  const sectionRef = useRef(section);
  const dealTypeRef = useRef(dealType);

  sectionRef.current = section;
  dealTypeRef.current = dealType;

  useEffect(() => {
    const consumer = createConsumer({ topic: 'recommendations' });

    const recommendationsSubscriber = createSubscriber((event: IEvent<unknown>) => {
      const eventData = event as TRecommendationsEvent;
      const currentSection = sectionRef.current;
      const currentDealType = dealTypeRef.current;

      switch (eventData.type) {
        case 'click': {
          const { suffix, offerId } = eventData.value;

          if (offerId) {
            trackRecommendationItemClick(currentDealType, currentSection, eventData.value.products);
          } else if (suffix) {
            trackTrapRecommendationClick(currentDealType, suffix, currentSection);
          }

          break;
        }
        case 'showTrap':
          trackRecommendationsTrapView(currentDealType, eventData.value.suffix, currentSection);

          break;
      }
    });

    consumer.subscribe(recommendationsSubscriber);

    return () => {
      consumer.unsubscribe(recommendationsSubscriber);
      consumer.destroy();
    };
  }, []);
};
